import React from 'react';
import { IconTextButton } from '../Button';
// @ts-ignore
import checkmarkIcon from '../../image-assets/icon.checkmark.svg';
import './PillToggle.css';

interface PillToggleProps {
  label: string;
  isSelected: boolean;
  onToggle: () => void;
  size?: 'small' | 'medium';
  className?: string;
}

const PillToggle: React.FC<PillToggleProps> = ({
  label,
  isSelected,
  onToggle,
  size = 'small',
  className
}) => {
  return (
    <div className={`pill-toggle ${className || ''}`}>
      <IconTextButton
        variant={isSelected ? "primary" : "secondary"}
        size={size}
        onClick={onToggle}
        icon={isSelected ? checkmarkIcon : undefined}
        iconAlt={isSelected ? "Selected" : undefined}
      >
        {label}
      </IconTextButton>
    </div>
  );
};

export default PillToggle; 